<template>
  <section class="section">
    <div class="container">
      <h1 class="is-size-2 has-text-centered">403 - Forbidden</h1>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Forbidden',
})
export default class Forbidden extends Vue {}
</script>
